/**
 * formId → 前端路由 path 映射表
 *
 * 由 App.tsx 的路由註解（含 pwXXXfX formId 的 JSX 註解）自動抽取產生，
 * 用於鏈駕駛艙「開啟表單」按鈕組 URL。
 * 注意：App.tsx 路由 path 不是 /{formId}，新模組多為 /{code}（如 pwc204f1 → /c204），
 * 舊模組用語意 slug（如 pwc202f1 → /sc、pwc203f1 → /shipping-order），故需查表 + 啟發式 fallback。
 */
export const FORM_ROUTE_MAP: Record<string, string> = {
  "pw0113f1": "pw0113f1",
  "pw0308f1": "pw0308",
  "pw030af1": "pw030a",
  "pw1103f1": "business-card",
  "pw1104f1": "company",
  "pw1105f1": "warehouse-location",
  "pw1106f1": "dept",
  "pw110cf1": "remark",
  "pw110hf1": "vendor-eval",
  "pw1111f1": "material",
  "pw1113f1": "product",
  "pw1114f1": "color-code",
  "pw1115f1": "pw1115f1",
  "pw1117f1": "trade-terms",
  "pw1118f1": "product-grade",
  "pw111af1": "test-item",
  "pw111gf1": "insp-method",
  "pw111hf1": "quality-req",
  "pw1304f1": "p1304",
  "pw1306f1": "dept-report",
  "pw1308f1": "currency-report",
  "pw1311f1": "material-report",
  "pw1312f1": "pw1312",
  "pw1313f1": "pw1313",
  "pw1314f1": "color-report",
  "pw1315f1": "pw1315",
  "pw131kf1": "p131k",
  "pw150hf1": "pw150h",
  "pw150kf1": "pw150k",
  "pw15mhf1": "p15mh",
  "pw15mjf1": "p15mj",
  "pw2201f1": "p2201",
  "pw2202f1": "pw2202",
  "pw2203f1": "pw2203",
  "pw2204f1": "pw2204f1",
  "pw220af1": "pw220a",
  "pw2501f1": "pw2501",
  "pw9101f1": "employee",
  "pw9103f1": "job-grade",
  "pw9108f1": "leave-type",
  "pw910cf1": "pw910cf1",
  "pw910gf1": "work-schedule",
  "pw910jf1": "vp-approval-priority",
  "pw910qf1": "dept-major",
  "pw910tf1": "emp-group",
  "pw9119f1": "pw9119",
  "pw9132f1": "pay-item",
  "pw9136f1": "labor-ins",
  "pw9137f1": "nhi-params",
  "pw9138f1": "pension-params",
  "pw913df1": "casual-payroll",
  "pw9201f1": "pw9201",
  "pw9204f1": "pw9204f1",
  "pw9205f1": "pw9205",
  "pw9207f1": "p9207",
  "pw9208f1": "pw9208",
  "pw9209f1": "p9209",
  "pw9210f1": "pw9210f1",
  "pw9213f1": "pw9213",
  "pw9220f1": "pw9220",
  "pw9221f1": "pw9221f1",
  "pw9224f1": "pw9224",
  "pw922af1": "p922a",
  "pw9233f1": "pw9233",
  "pw9236f1": "pw9236f1",
  "pw9301f1": "p9301",
  "pw9304f1": "pw9304",
  "pw9306f1": "p9306",
  "pw930bf1": "pw930b",
  "pw930hf1": "p930h",
  "pw9310f1": "p9310",
  "pw9311f1": "p9311",
  "pw9315f1": "p9315",
  "pw9321f1": "pw9321",
  "pw9324f1": "pw9324",
  "pw9334f1": "pw9334",
  "pw9335f1": "pw9335",
  "pw9336f1": "pw9336",
  "pw9337f1": "pw9337",
  "pw9339f1": "pw9339",
  "pw933af1": "pw933a",
  "pw933bf1": "pw933b",
  "pw9341f1": "pw9341",
  "pw9403f1": "pw9403",
  "pw9404f1": "pw9404",
  "pw9410f1": "attendance-status",
  "pw9411f1": "pw9411",
  "pw9513f1": "p9513",
  "pw9531f1": "pw9531",
  "pw9614f1": "pw9614",
  "pw9701f1": "pw9701",
  "pw98m2f1": "pw98m2",
  "pwb151f1": "office-supplies",
  "pwb255f1": "b255",
  "pwc201f1": "pwc201f1",
  "pwc202f1": "sc",
  "pwc203f1": "shipping-order",
  "pwc204f1": "c204",
  "pwc205f1": "c205",
  "pwc208f1": "c208",
  "pwc209f1": "c209",
  "pwc212f1": "c212",
  "pwc301f1": "pwc301",
  "pwc304f1": "c304",
  "pwc305f1": "c305",
  "pwc315f1": "pwc315",
  "pwc322f1": "c322",
  "pwc324f1": "c324",
  "pwc330f1": "c330",
  "pwc358fa": "c358",
  "pwc502f1": "c502",
  "pwc504f1": "c504",
  "pwc514f1": "c514",
  "pwc516f1": "c516",
  "pwc526f1": "c526",
  "pwc5m2f1": "c5m2",
  "pwc5m4f1": "c5m4",
  "pwc5n4f1": "c5n4",
  "pwc5n6f1": "c5n6",
  "pwc901fg": "c901g",
  "pwd103f1": "d103",
  "pwd201f1": "d201",
  "pwd202f1": "d202",
  "pwd203f1": "d203",
  "pwd204f1": "d204",
  "pwd205f1": "d205",
  "pwd206f1": "d206",
  "pwd210f1": "pwd210",
  "pwd211f1": "d211",
  "pwd212f1": "pwd212",
  "pwd214f1": "d214",
  "pwd216f1": "pwd216",
  "pwd217f1": "pwd217",
  "pwd301f1": "d301",
  "pwd302f1": "d302",
  "pwd303f1": "d303",
  "pwd304f1": "d304",
  "pwd305f1": "d305",
  "pwd306f1": "d306",
  "pwd309f1": "d309",
  "pwd310f1": "pwd310",
  "pwd312f1": "d312",
  "pwd313f1": "d313",
  "pwd314f1": "d314",
  "pwd318f1": "warehouse-return-stats",
  "pwd319f1": "d319",
  "pwd320f1": "d320",
  "pwd324f1": "d324",
  "pwd328f1": "d328",
  "pwd501f1": "d501",
  "pwd502f1": "d502",
  "pwd506f1": "d506",
  "pwd512f1": "pwd512",
  "pwd5m1f1": "d5m1",
  "pwd5m2f1": "d5m2",
  "pwd5m3f1": "d5m3",
  "pwd5m4f1": "d5m4",
  "pwg201f1": "pwg201",
  "pwg203f1": "g203",
  "pwg204f1": "g204",
  "pwg208f1": "pwg208",
  "pwg305f1": "g305",
  "pwg306f1": "g306",
  "pwg319f1": "g319",
  "pwg332f1": "pwg332",
  "pwg501f1": "pwg501",
  "pwh201f1": "pwh201",
  "pwh203f1": "pwh203",
  "pwh204f1": "pwh204",
  "pwh205f1": "pwh205",
  "pwh301f1": "h301",
  "pwh302f1": "h302",
  "pwh303f1": "h303",
  "pwh311f1": "h311",
  "pwh312f1": "h312",
  "pwj201f1": "j201",
  "pwj202f1": "j202",
  "pwj203f1": "j203",
  "pwj207f1": "j207",
  "pwj208f1": "j208",
  "pwj209f1": "j209",
  "pwj212f1": "j212",
  "pwj214f1": "j214",
  "pwj218f1": "j218",
  "pwj219f1": "j219",
  "pwj220f1": "pwj220",
  "pwj30cf1": "j30c",
  "pwj310f1": "pwj310",
  "pwj501f1": "j501",
  "pwj502f1": "j502",
  "pwj508f1": "pwj508",
  "pwj514f1": "j514",
  "pwj515f1": "j515",
  "pwj5m1f1": "j5m1",
  "pwj5m2f1": "j5m2",
  "pwj5m3f1": "j5m3",
  "pwj5m7f1": "pwj5m7",
  "pwj5m8f1": "j5m8",
  "pwj5n4f1": "j5n4",
  "pwj5n5f1": "j5n5",
  "pwj5n8f1": "j5n8",
  "pwl102f1": "doc-setup",
  "pwl202f1": "l202",
  "pwl204f1": "l204",
  "pwl205f1": "l205",
  "pwl303f1": "l303",
  "pwl304f1": "pwl304",
  "pwl313f1": "l313",
  "pwl316f1": "l316",
  "pwl402f1": "l402",
  "pwl413f1": "l413",
  "pwm101f1": "inv-move-cat",
  "pwm104f1": "inv-reason",
  "pwm105f1": "inv-process",
  "pwm106f1": "m106",
  "pwm201f1": "m201",
  "pwm202f1": "pwm202",
  "pwm207f1": "m207",
  "pwm209f1": "m209",
  "pwm211f1": "pwm211",
  "pwm301f1": "m301",
  "pwm302f1": "m302",
  "pwm303f1": "m303",
  "pwm305f1": "m305",
  "pwm309f1": "m309",
  "pwm310f1": "m310",
  "pwm501f1": "m501",
  "pwm203f1": "m203",
  "pwm503f1": "m503",
  "pwm5m1f1": "m5m1",
  "pwm5m3f1": "m5m3",
  "pwm5m8f1": "m5m8",
  "pwn101f1": "complaint-cause",
  "pwn102f1": "complaint-desc",
  "pwn201f1": "pwn201",
  "pwn202f1": "n202",
  "pwn211f1": "n211",
  "pwn301f1": "n301",
  "pwn351f1": "n351",
  "pwn501f1": "n501",
  "pwn502f1": "n502",
  "pwn503f1": "n503",
  "pwn5m3f1": "n5m3",
  "pwn5p1f1": "n5p1",
  "pwp151f1": "pack-customer",
  "pwp201f1": "inspection-request",
  "pwp203f1": "p203",
  "pwp211f1": "pwp211",
  "pwp251f1": "pwp251",
  "pwp252f1": "pwp252",
  "pwp253f1": "pwp253",
  "pwp254f1": "pwp254",
  "pwp255f1": "pwp255",
  "pwp303f1": "pwp303",
  "pwp503f1": "p503",
  "pwp5m3f1": "p5m3",
  "pwr211f1": "r211",
  "pwr5d2f1": "r5d2",
  "pwr5d5f1": "r5d5",
  "pwr5d6f1": "r5d6",
  "pwr5j3f1": "pwr5j3",
  "pwr5m3f1": "r5m3",
  "pwr5m8f1": "r5m8",
  "pwr5npf1": "r5np",
  "pwt102f1": "announcement",
  "pwt202f1": "t202",
  "pwt205f1": "pwt205",
  "pwt206f1": "t206",
  "pwt207f1": "t207",
  "pwt20af1": "t20a",
  "pwt402f1": "announcement-query",
  "pwt5m2f1": "t5m2",
};

/**
 * 取得 formId 對應的前端路由（含前導斜線）。
 * 1. 查映射表（最可靠）
 * 2. 啟發式：pw{code}fX → /{code}（多數新模組規則）
 * 3. 最後 fallback：/{formId}
 */
export function getFormRoute(formId: string): string {
  const id = formId.toLowerCase();
  const mapped = FORM_ROUTE_MAP[id];
  if (mapped) return '/' + mapped;
  const m = id.match(/^pw([a-z0-9]+?)f[0-9a-z]$/);
  if (m) return '/' + m[1];
  return '/' + id;
}
